import { serifStyles } from "@pathwright/blocks/src/ui/typography"
import { getPrimaryColor } from "@pathwright/ui/src/components/utils/colors"
import styled from "styled-components"

const mobile = `@media screen and (max-width: 780px)`

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const baseSubmitWrapper = styled.div`
  /* width: 80%; */
  margin: 0 auto;
  max-width: 1000px;
  padding: 2rem 0;

  ${mobile} {
    padding: 1.5rem 0;
  }

  .FeedbackEdit,
  .FeedbackView {
    display: flex;
    justify-content: center;
    margin: 0 auto;

    h3 {
      text-align: center;
      margin-bottom: 0.2rem;
    }
  }
`

export const SubmitEditWrapper = styled(baseSubmitWrapper)`
  .quill {
    .ql-editor {
      &::before,
      & > p {
        text-align: center;
      }
    }
  }

  .TextArea__input textarea::placeholder {
    color: rgba(0, 0, 0, 0.4);
    font-style: italic;
  }
`

export const SubmitViewWrapper = styled(baseSubmitWrapper)`
  .FeedbackView {
    width: 80% !important;
  }

  .ql-editor > p {
    word-break: break-word;
  }
`

export const ChooseFileTypeWrapper = styled(Row)`
  width: 80%;
  margin: 0 auto 10px;

  ${mobile} {
    flex-direction: column;
    width: 100%;
  }
`

export const SelectWrapper = styled.div`
  .Select-value-label {
    color: ${getPrimaryColor()};
  }
  .Select-input:focus {
    background-color: transparent !important;
  }

  .Select-menu-outer {
    background-color: white;
    border-radius: 5px;
    border: 1px solid #ddd !important;
  }

  .Select-menu-outer {
    z-index: 1000;
  }
`

export const SubmitInnerUI = styled.div`
  ${(p) =>
    p.disableInput
      ? `
    cursor: not-allowed !important;
  `
      : ``}
  width: 80%;
  margin: 0 auto;
  max-width: 800px;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  padding: 3rem 1.5rem;
  border-radius: 4px;
  position: relative;

  .MeetingButton {
    text-decoration: none !important;
  }

  ${mobile} {
    padding: 2rem 1rem;
    width: 100%;
  }

  .TextArea .TextArea__input textarea {
    border: none;
    text-align: center;
  }

  .MetaText {
    margin-bottom: 1rem;
  }

  .SubmitEdit__prompt .TextArea .TextArea__input textarea,
  .MetaText > p {
    ${serifStyles()}
    font-style: normal;
  }
`

// Possible option for the clear button

export const FilePickerUploaderWrapper = styled(SubmitInnerUI)`
  padding-left: 2rem;
  padding-right: 2rem;
`

export const FilePickerPreviewerWrapper = styled(SubmitInnerUI)`
  padding-left: 2rem;
  padding-right: 2rem;
  position: relative;

  .FilePickerPreviewer__clear-button {
    position: absolute;
    top: 3px;
    right: 3px;
  }

  ${mobile} {
    padding: 2rem 1rem;

    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .OverlayTrigger--show .Overlay {
    min-width: 250px;
    min-height: 250px;
  }
`
